// Basitleştirilmiş reportWebVitals sürümü
const reportWebVitals = () => {
    // Bu fonksiyon boş bırakılabilir, performans metrikleri şu anda gerekli değil
    // Web vitals paketi olmadan da çalışabilir
};

export default reportWebVitals; 